import { Clock, CheckCircle2, XCircle } from "lucide-react";

const map = {
  en_attente: { label: "En attente", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Clock },
  approuve: { label: "Approuvé", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  rejete: { label: "Rejeté", cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle },
};

export default function StatusBadge({ status }) {
  const s = map[status] || map.en_attente;
  const Icon = s.Icon;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${s.cls}`}>
      <Icon className="h-3 w-3" />
      {s.label}
    </span>
  );
}
